// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersModelsClsInboundConsent {
    'service'?: string | null;
    'patientresponse'?: string | null;
    'patientresponsedate'?: string | null;
    'hcpresponse'?: string | null;
    'hcpresponsedate'?: string | null;
    'legalguardianresponse'?: string | null;
    'legalguardianresponsedate'?: string | null;
    'consenttype'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersModelsClsInboundConsent>> = [
        {
            "name":     "service",
            "baseName": "service",
            "type":     "string"
        },
        {
            "name":     "patientresponse",
            "baseName": "patientresponse",
            "type":     "string"
        },
        {
            "name":     "patientresponsedate",
            "baseName": "patientresponsedate",
            "type":     "string"
        },
        {
            "name":     "hcpresponse",
            "baseName": "hcpresponse",
            "type":     "string"
        },
        {
            "name":     "hcpresponsedate",
            "baseName": "hcpresponsedate",
            "type":     "string"
        },
        {
            "name":     "legalguardianresponse",
            "baseName": "legalguardianresponse",
            "type":     "string"
        },
        {
            "name":     "legalguardianresponsedate",
            "baseName": "legalguardianresponsedate",
            "type":     "string"
        },
        {
            "name":     "consenttype",
            "baseName": "consenttype",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersModelsClsInboundConsent.attributeTypeMap;
    }
}
